import { Button } from 'antd';
import React from 'react';
import { ModalHandler } from 'components/Modal';
import bankLogo from 'static/images/bank.png';
import { getMaskText } from 'utils/util';
import { BankAccountMainTypeMap } from '../config';
import * as Tags from '../Tags';
import { BankCardItemTypes } from '../type';
import './style.scss';

export interface CardListProps {
    data?: BankCardItemTypes[];
    onEdit?: (info: BankCardItemTypes) => void;
    onAdd?: () => void;
    showStatusTag?: boolean;
}

const CardList: React.FC<CardListProps & ModalHandler> = ({ close, data, onEdit, onAdd, showStatusTag }) => {
    const handleCardItem = (item: BankCardItemTypes) => {
        close(item);
    };

    const handleEdit = (item: BankCardItemTypes) => {
        onEdit?.(item);
        close();
    };

    const handleAdd = () => {
        onAdd?.();
        close();
    };

    return (
        <div className="card-list-root">
            <div className="list-box">
                {data?.map((item, index) => {
                    const { bankName, bankAccount, status, needAuthenticated, bankAccountMainType } = item;

                    return (
                        <div
                            key={index}
                            className="card-box"
                            onClick={() => {
                                handleCardItem(item);
                            }}>
                            <img src={bankLogo} className="bank-logo" alt="" />
                            <div className="content">
                                <div className="bank-info">
                                    <div className="bank-header">
                                        <div className="bank-name" title={bankName}>
                                            {bankName}
                                        </div>
                                        {typeof status === 'number' && showStatusTag && (
                                            <Tags.BankCardAuthStatusTag
                                                status={status}
                                                needAuthenticated={needAuthenticated}
                                            />
                                        )}
                                    </div>
                                    <div className="bank-account">
                                        {bankAccountMainType ? `${BankAccountMainTypeMap[bankAccountMainType]} ` : ''}
                                        {getMaskText(bankAccount)}
                                    </div>
                                </div>
                            </div>
                            {!!onEdit && (
                                <Button
                                    type="link"
                                    className="edit"
                                    onClick={(e: React.FormEvent) => {
                                        e.stopPropagation();

                                        handleEdit(item);
                                    }}>
                                    {__('Edit')}
                                </Button>
                            )}
                        </div>
                    );
                })}
            </div>
            {!!onAdd && (
                <Button className="btn-add mt-4" block type="primary" onClick={handleAdd}>
                    {__('Add Wire Profile')}
                </Button>
            )}
        </div>
    );
};

export default CardList;
